import Init from './init'
import ApiHttpClient from '@/core/api-http-client';

export default class Auth extends Init {
  static authenticate() {
    return Auth.start()
  }

  static check(msisdn, cpf) {
    return ApiHttpClient
      .createInstance()
      .get('/reinit', {
        params: {
          msisdn,
          cpf,
        }
      });
  }
}
